var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"SmartPolicing"}},[_c('view1'),_c('view2'),_c('view3'),_c('view4'),_c('view5'),_c('view6'),_c('view7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }